const types = {
    SET_VIEW_KEYS: '[QIWI] SET VIEW KEYS',
}

export {
    types
}